<template>
  <div class="tongyongdl" style="min-height:700px;margin-bottom:3px">
      <div class="xuexijieshao" v-for="(item,index) in sp" :key="index">
          <div  class="jieshaoheadlf" @click="showif(index)">培训视频：{{item.title}}<div class="jieshaoheadri">课程简介<div
                      v-bind:class="[item.show ? 'imgbuy': 'imgbuy1']"
                      class="imgs  imgri"
                    ></div></div></div>
        <div style="position:relative" :class="[item.show ? 'play': 'playnone']"><div class="sanjiao"></div><div class="sanjiaotext" ><div class="textt" v-for="(it,id) in item.text" :key="id"><div class="timing">{{item.time[id]}}</div>{{it}}</div></div></div>
        <div style="margin-top:10px" class="xz">
            <div><div class="shipin" @click="clicktjnew(item.seetj)">在线观看</div><span>观看次数{{item.see}}次</span></div>
           <!-- <div> <div class="ppt" @click="clicktj(item.dltj)">下载培训PPT</div><span>下载次数{{item.dl}}次</span></div> -->
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import vcd from "./vcd.vue"
export default {
data(){
    return{
        ts:'',
        kg:'',
        sp:[{title:'wh7高级技术分析技巧解析',
        show:false,
        dl:0,
        see:0,
        dltj:15,
        seetj:14,  
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E9%AB%98%E7%BA%A7%E6%8A%80%E6%9C%AF%E5%88%86%E6%9E%90%E6%8A%80%E5%B7%A7%E8%A7%A3%E6%9E%90ppt.rar',
        text:['- 扩展分析工具和F9商品深度资料','- 云端选股与云端预警  ','- 基于线性回归方程的价格走势判断方法','- 云端选股公式的编写及使用方法','- 探寻商品波动率及周期性变化规律','- 云端形态选股的使用方法','- 基本面与技术面相结合的远期链分析 ','- 云端公式预警、趋势线预警使用方法'],
        time:['1′56"','1h26′13"','6′31"','1h26′22"','28′55"','2h13′05"','1h10′27"','2h21′30"'],
        },{title:'如何提高套利收益',
        show:false,
        dl:0,
        see:0,
        dltj:17,
        seetj:16, 
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E5%A6%82%E4%BD%95%E6%8F%90%E5%A5%97%E5%88%A9%E6%94%B6%E7%9B%8Appt.rar',
        text:['- 什么是套利','- 跨期套利—如何避免瘸腿 ','- 套利的优势','- 跨品种套利—如何配比手数','- 期货套利交易类型','- 跨市场套利—如何精确配比','- 套利交易的注意事项'],
        time:['2′5"','21′00"','9′0"','1h0′05"','14′15"','1h8′15"','16′05"'],
       },{title:'wh7机构交易工具',
        show:false,
        dl:0,
        see:0,
        dltj:21,
        seetj:20, 
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E5%A6%82%E4%BD%95%E6%8F%90%E5%A5%97%E5%88%A9%E6%94%B6%E7%9B%8Appt.rar',
        text:['- 下单任务管理器','- 文件下单','- 算法交易','- 多账号管理','- 网格交易运行池'],
       time:['2′25"','1h16′35"','37′38"','1h21′32"','1h6′7"'],
       },
       {title:'用wh7软件做期货套利交易',
        show:false,
        dl:0,
        see:0,
        dltj:25,
        seetj:24, 
        // pptlj:'https://ftpc.wenhua.com.cn/files/guide/wh7-v7.0/download/wh7%E5%A6%82%E4%BD%95%E6%8F%90%E5%A5%97%E5%88%A9%E6%94%B6%E7%9B%8Appt.rar',
        text:['- 什么是统计套利','- 套利下单工具 ','- 专业的套利历史数据','- 套利算法交易辅助','- 套利扩展分析工具'],
        time:['19′30"',' 1h01′26"','31′00"','1h14′45"',' 48′58"',],
       }]
    }
},
methods:{
showif(id){
    this.sp[id].show=!this.sp[id].show
},
clicktj(el){
//     axios.get("dl.asp?mod=dl&id="+ el +"").then((res)=>{
// this.ts=res
//   }).catch((err)=>{console.log(err);})
  window.location.href="/dl.asp?mod=dl&id="+ el +""
// window.open(lj, "_blank");
},
clicktjnew(lj){
// var mask_bg = document.createElement("div");
//     mask_bg.id = "mask_bg";
//     mask_bg.style.position = "fixed";
//     mask_bg.style.top = "0px";
//     mask_bg.style.left = "0px";
//     mask_bg.style.width = "100%";
//     mask_bg.style.height = "100%";
//     mask_bg.style.backgroundColor = "rgba(0,0,0,0.6)";
//     // mask_bg.style.opacity = 0.6;
//     mask_bg.style.zIndex = 1111111;
//     document.body.appendChild(mask_bg);
//     var alertcont =document.createElement('div');
    
//     alertcont.style.width='1000px'
//     alertcont.style.height='600px'
//     alertcont.style.position='fixed'
//     alertcont.style.background='black'
//     alertcont.style.left='20%'
//     alertcont.style.top='20%'
//     alertcont.style.zIndex = 111111111;
//     mask_bg.appendChild(alertcont);
//     var alertcont2=document.createElement('div');
//     alertcont2.style.position='relative'
//     alertcont2.style.width='100%'
//     alertcont2.style.height='100%'
//     alertcont.appendChild(alertcont2);
//     var bao=document.createElement('iframe');
//     bao.src="/dl.asp?mod=dl&id="+ lj +""
//     bao.style.width='100%'
//     bao.style.height='100%'
//     alertcont2.appendChild(bao);
//     var chabox =document.createElement('div');
//     chabox.innerHTML='x'
//     chabox.style.color='white'
//     chabox.style.position='absolute'
//     chabox.style.right='-5px'
//     chabox.style.top='0'
//     chabox.style.width='15px'
//     chabox.style.height='15px'
//     chabox.style.cursor='pointer'
//     chabox.onclick=function(){
//         var mask_bg = document.getElementById("mask_bg");
//     if (mask_bg != null)
//         mask_bg.parentNode.removeChild(mask_bg);
//     }
//     alertcont2.appendChild(chabox);
let target=this.$root.$frame.box(vcd,{
    unvariable:false,
    width:'1000px',
    height:'600px',
    props:{
        src:"/dl.asp?mod=dl&id="+ lj +""
    }
})
}
},
created(){
    var data=[14,15,16,17,20,21,24,25]
    data.forEach((el,idx)=>{
axios.get("dl.asp?mod=cat&id="+ el +"").then((res)=>{
var cont=Math.floor( idx/2 )   

if(idx%2==0){
this.sp[cont].see=res.data
}
else{
    this.sp[cont].dl=res.data
}
  }).catch((err)=>{console.log(err);})
    })
    
  

  }


}
</script>

<style scoped>
.zhedang{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: black;
    opacity: 0.6;
    z-index: 55555555;
    /* display: none; */
}
.xz span{
    display: inline-block;
    margin-left: 10px;
    font-size: 13px;
    color: #8b8c8c;
}
.shipin{
    background: url("../../../../assets/images/bof.png") no-repeat 15px center;
    background-color: #364064;
    height: 30px;
    color: white;
    line-height: 30px;
    padding-left: 35px;
    width: 75px;
    margin: 20px 0;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-size: 15px;
}
.ppt{
   background: url("../../../../assets/images/xiaz.png") no-repeat 15px center;
    background-color: #c4954d;
    height: 30px;
    color: white;
    line-height: 30px;
    padding-left: 35px;
    width: 100px;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-size: 15px;
}
.play{
    display: block;
}
.textt{
    width: 330px;
    display: inline-block;
    color: #8b8c8c;
    padding: 10px 0;
    font-size: 14px;
}
.playnone{
    display: none;
}
.xuexijieshao{
    width: 920px;
    margin: 0 auto;
    padding: 45px 0;
    border-bottom:1px gray dashed ;
}
.xuexijieshao:last-child{
    border: none;
}
.jieshaoheadlf{
    color: rgb(39, 84, 121);
    font-size: 15px;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
}
.jieshaoheadri{
    font-size: 14px;
    margin-left: 15px;
    display: inline-block;
    color: #364064;
}
.imgs {
  display: inline-block;
  margin-left: 4px;
  
  cursor: pointer;
  width: 13px;
  height: 10px;
}
.imgbuy {
  background: url("../../../../assets/images/jiantouxia.png") no-repeat center;
}
.imgbuy1 {
  background: url("../../../../assets/images/jiantoushang.png") no-repeat center;
}
.sanjiao{
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg); /* IE 9 */
  -moz-transform: rotate(45deg); /* Firefox */
  -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
  -o-transform: rotate(45deg); /* Opera */
  background: #f2f3f9;
  position: absolute;
  left: 100px;
  top: -6px;
}
.sanjiaotext{
    margin-top: 15px;
    background: #f2f3f9;
    width: 665px;
    min-height: 55px;
    padding: 20px 10px;
}
.timing{
    display: inline-block;
    width: 63px;
    text-align: right;

}
</style>